import { push } from 'connected-react-router';

import { ActionType } from '../infrastructure/actionTypes';
import * as GoogleAnalyticsEvents from "../infrastructure/GoogleAnalyticsEvents";
import { IOrder, IOrderStatus, IDocument, IOrderQuantities_Addresses } from '../infrastructure/interfaces';
import OrderService from '../services/OrderService';


export const getOrdersList = (userID: string) => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    OrderService
      .getOrdersList(userID)
      .then((ordersList: IOrder[]) => {
        // HACK: Remove digital and print download orders
        ordersList = ordersList.filter((o: IOrder) => ((o.status_id != 7) && (o.status_id != 8)))
        dispatch({ type: ActionType.STOP_LOADING });
        dispatch({ type: ActionType.GET_ORDERS_LIST_DONE, ordersList });
      })
      .catch(error => console.error(error));
  };
};

export const getOrderTypeCount = (status_id: number) => {
  return (dispatch: any) => {
    OrderService
      .getOrderCount(status_id)
      .then((orderCount) => {
        dispatch({
          type: ActionType.GET_ORDER_TYPE_COUNT,
          orderCount,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }
}
export const getAdminOrdersList = (startIndex: Number, listSize: Number, orderCategory: Number) => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    OrderService
      .getAdminOrderList(startIndex, listSize, orderCategory)
      .then((orders: IOrder[]) => {
        // HACK: Remove digital and print download orders
        orders = orders.filter((o: IOrder) => ((o.status_id != 7) && (o.status_id != 8)))
        dispatch({ type: ActionType.STOP_LOADING });
        dispatch({
          type: ActionType.GET_ADMIN_ORDERS_LIST_DONE,
          orders,
        });
      })
      .catch((error) => {
        console.error(error);
        dispatch({ type: ActionType.STOP_LOADING });
      });
  };
};

export const getOrdersPlacedReport = () => {

  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    OrderService
      .getOrdersPlacedReport()
      .then((reportRows) => {
        dispatch({ type: ActionType.STOP_LOADING });
        dispatch({
          type: ActionType.GET_ORDER_PLACED_REPORT_DONE,
          reportRows,
        });
      })
      .catch((error) => {
        console.error(error);
        dispatch({ type: ActionType.STOP_LOADING });
      });
  };
};

export const getOrdersCostReport = () => {

  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    OrderService
      .getOrderCostReport()
      .then((costReportRows) => {
        dispatch({ type: ActionType.STOP_LOADING });
        dispatch({
          type: ActionType.GET_ORDER_COST_REPORT_DONE,
          costReportRows,
        });
      })
      .catch((error) => {
        console.error(error);
        dispatch({ type: ActionType.STOP_LOADING });
      });
  };
};

export const placeOrder = (document: IDocument,
                           user_id: string,
                           user_email: string,
                           username: string,
                           comments: string,
                           orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    OrderService
      .placeOrder(document, user_id, user_email, comments, orderQuantitiesAddresses)
      .then((order: any) => {
        order.username = username
        order.document = document
        order.last_modified = order.created_at
        order.comments = comments
        order.orderQuantitiesAddresses = orderQuantitiesAddresses

        GoogleAnalyticsEvents.placedOrder(order);
        dispatch({
          type: ActionType.CREATE_ORDER_DONE,
          order,
        });

        OrderService
          .getOrdersList(user_id)
          .then((ordersList: IOrder[]) => {
            // HACK: Remove digital and print download orders
            ordersList = ordersList.filter((o: IOrder) => ((o.status_id != 7) && (o.status_id != 8)))
            dispatch({ type: ActionType.STOP_LOADING });
            dispatch({ type: ActionType.GET_ORDERS_LIST_DONE, ordersList });
          })
          .catch(error => console.error(error));
        dispatch(push('/Home?currentTab=1'));
      })
      .catch(error => console.log(error));
  };
};

export const hideOrderModal = () => {
  return (dispatch: any) => {
    dispatch({
      type: ActionType.CREATE_ORDER_DISMISSED,
    });
  }
}

export const changeOrderStatus = (order: IOrder, status_id: number) => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    OrderService.changeOrderStatus(order, status_id)
      .then((updatedOrder) => {
        GoogleAnalyticsEvents.changedOrderStatus(order);
        dispatch({ type: ActionType.STOP_LOADING });
        dispatch({
          type: ActionType.CHANGE_ORDER_STATUS_DONE,
          order: updatedOrder,
        });
      })
      .catch((error) => {
        console.error(error);
        dispatch({ type: ActionType.STOP_LOADING });
      });
  };
};

export const getStatuses = () => {
  return (dispatch: any) => {
    OrderService.getStatuses()
      .then((statuses: IOrderStatus[]) => {
        dispatch({ type: ActionType.GET_ORDER_STATUSES_DONE, statuses });
      })
      .catch(error => console.log(error));
  };
};


export const deleteOrder = (order: IOrder) => {
  return (dispatch: any) => {
    OrderService.deleteOrder(order.id)
      .then(() => {
        GoogleAnalyticsEvents.deleteOrder(order);
        dispatch({ type: ActionType.DELETE_ORDER, id: order.id });
        dispatch({ type: ActionType.DECREMENT_ORDER_TYPE_COUNT});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/orderActions.ts